import { clickable, isPresent } from 'ember-cli-page-object';
import { settled } from '@ember/test-helpers';

export const selectors = {
  body: '.hds-modal__body',
  closeButton: '.hds-dismiss-button',
  container: '.hds-modal',
  footer: '.hds-modal__footer',
  header: '.hds-modal__header',
  title: '.hds-modal__title',
};

export default {
  scope: selectors.container,
  isPresent: isPresent(),
  closeButton: {
    scope: selectors.closeButton,
    click: clickable(),
    isPresent: isPresent(),
  },
  async dismiss() {
    await this.closeButton.click();
    return await settled();
  },
  header: {
    scope: selectors.header,
    isPresent: isPresent(),
  },
  body: {
    scope: selectors.body,
    isPresent: isPresent(),
  },
  footer: {
    scope: selectors.footer,
    isPresent: isPresent(),
  },
};
